import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledBlockShortAdvanceBookingField = styled(StyledFlex)`
   margin-right: auto;
`;
